import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/pages/home/home'
import AboutUs from '@/pages/about-us/about-us'
import FAQ from '@/pages/faq/faq'
import ComfortCare from '@/pages/faq/comfort-care/comfort-care'
import BrushingAndFlossing from '@/pages/faq/brushing-and-flossing/brushing-and-flossing'
import Treatment from '@/pages/treatment/treatment'
import EarlyTreatment from '@/pages/treatment/early-treatment/early-treatment'
import NewPatients from '@/pages/new-patients/new-patients'
import FunZone from '@/pages/fun-zone/fun-zone'
import FinancialInsurance from '@/pages/financial-and-insurance/financial-and-insurance'
import Contact from '@/pages/contact-us/contact-us'
import OralHealthPartnerships from '@/pages/oral-health-partnerships/oral-health-partnerships'
import Publications from '@/pages/publications/publications'
import Accessibility from '@/pages/accessibility/accessibility'
import Reviews from '@/pages/reviews/reviews'

import PageNotFound from '@/pages/404/404'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: false,
      component: Home
    },
    {
      path: '/about-us',
      name: 'About Us',
      navigation: true,
      component: AboutUs
    },
    {
      path: '/new-patients',
      name: 'New Patients',
      navigation: true,
      component: NewPatients
    },
    {
      path: '/treatment',
      name: 'Treatment',
      navigation: true,
      component: Treatment
    },
    {
      path: '/treatment/early-treatment',
      name: 'Early Treatment',
      navigation: false,
      component: EarlyTreatment
    },
    {
      path: '/faq',
      name: 'FAQ',
      navigation: true,
      component: FAQ
    },
    {
      path: '/faq/brushing-and-flossing',
      name: 'Brushing And Flossing',
      navigation: false,
      component: BrushingAndFlossing
    },
    {
      path: '/faq/comfort-care',
      name: 'Comfort Care',
      navigation: false,
      component: ComfortCare
    },
    {
      path: '/fun-zone',
      name: 'Fun Zone',
      navigation: true,
      component: FunZone
    },
    {
      path: '/financial-and-insurance',
      name: 'Financial & Insurance',
      navigation: false,
      component: FinancialInsurance
    },
    {
      path: '/publications',
      name: 'Awards',
      navigation: true,
      component: Publications
    },
    {
      path: '/reviews',
      name: 'Reviews',
      navigation: true,
      component: Reviews
    },
    {
      path: '/contact-us',
      name: 'Contact',
      navigation: true,
      component: Contact
    },
    // {
    //   path: '/school-oral-health',
    //   name: 'School Oral health',
    //   navigation: false,
    //   component: SchoolOralHealth
    // },
    {
      path: '/oral-health-partnerships',
      name: 'Oral Health Partnerships',
      navigation: false,
      component: OralHealthPartnerships
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    {
      path: '/*',
      name: 'page-not-found',
      navigation: false,
      component: PageNotFound
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 150 }
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js